import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "news" }
const _hoisted_2 = { class: "news-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "news-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "introduction" }
const _hoisted_9 = { class: "createTime" }
const _hoisted_10 = { class: "pagination" }
const _hoisted_11 = ["onClick"]

import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import store from '@/store';
// import ContactUs from '@/components/ContactUs.vue'
import { asynchronousRetrieval } from '@/utils'


// 组件名称，用于 keep-alive 的 include 属性匹配
// 必须与 App.vue 中 keepAliveComponents 数组中的名称一致
const __default__ = {
  name: 'NewsView'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loadUrl: any = ref({})
const newsListAll: any =  ref([])
const newsList: any = ref([])
const paginationIndex = ref(0)
const paginationValue = ref(1)

const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `新闻中心 / 新闻详情 / ${title}`
}

const changeData = (value: number) => {
  paginationIndex.value = value - 1;
  newsList.value = [...newsListAll.value].slice((value - 1) * 8, value * 8)
}

const formatDate = (timestamp: number) => {

   const date = new Date(timestamp)
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = date.getHours();
    const mx = date.getMinutes();
    const s = date.getSeconds();

    return `${y}-${m}-${d}`
}

const getData = (columnId: number) => {
  selectCommonElement({ columnId, appId: 2 }).then((res: any) => {
    newsListAll.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0))
    newsList.value = [...newsListAll.value].slice(paginationIndex.value * 8, (paginationIndex.value + 1) * 8)
    paginationValue.value = Math.ceil(newsListAll.value?.length / 8) || 0
  })
}

onMounted(async () => {
  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.news) {
    const news: any = await asynchronousRetrieval('webimg/images/about_us/news.png');
    loadUrl.value = { news }
  }

  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  const columnId = +path.query.type || 5
  
  // 条件判断：只有当数据为空时才请求接口
  // 因为组件被 keep-alive 缓存，再次进入页面时 onMounted 仍会执行
  // 但数据已经存在，不需要重新请求
  if (newsListAll.value.length === 0) {
    getData(columnId);
  }
})
watch(() => store.state.programmeIndex, (newState: any) => {
  getData(newState)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.news
      }, null, 8, _hoisted_3),
      _createElementVNode("div", null, _toDisplayString(_unref(store).state.programmeIndex == 6 ? '行业新闻' : '公司新闻'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (toOtherPath(item.relatedHtmlId, item.title))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.introduction), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(formatDate(item.newsTimestamp)), 1)
          ])
        ], 8, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: "prev",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeData(Math.max(0, paginationIndex.value - 1) + 1)))
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationValue.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (changeData(item)),
          class: _normalizeClass(paginationIndex.value == index ? 'active' : ''),
          key: item
        }, _toDisplayString(item), 11, _hoisted_11))
      }), 128)),
      _createElementVNode("div", {
        class: "next",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeData(Math.min(paginationIndex.value + 1, paginationValue.value - 1) + 1)))
      })
    ])
  ]))
}
}

})